// translations.ts
export interface Translations {
  // Labels
  pickup: string;
  delivery: string;
  youAre: string;
  shippingMethod: string;
  
  // Tabs
  national: string;
  international: string;

  // Placeholders
  enterCityOrZip: string;
  
  // Options
  selection: string;
  company: string;
  private: string;
  landFreight: string;
  airFreight: string;
  seaFreight: string;
  
  // Buttons
  compareNow: string;
  submitRequest: string;
  processing: string;
  understood: string;
  
  // Messages
  comingSoon: string;
  comingSoonMessage: string;
  pleaseEnterAddresses: string;
  pleaseSelectCustomerType: string;
  pleaseSelectShippingMethod: string;
  errorOccurred: string;
  searching: string;
  nationalOnlySwiss: string;
  internationalNeedsAbroad: string;
  
  // Aria labels
  clear: string;
}

export const translations: { de: Translations; en: Translations; fr: Translations; it: Translations } = {
  de: {
    // Labels
    pickup: "Abholung",
    delivery: "Lieferung",
    youAre: "Sie sind",
    shippingMethod: "Versandart",
    
    // Placeholders
    enterCityOrZip: "Ort oder PLZ eingeben",
    
    national: "Nationaler Versand",
    international: "Internationaler Versand",

    // Options
    selection: "Auswahl",
    company: "Firma",
    private: "Privat",
    landFreight: "Landfracht",
    airFreight: "Luftfracht",
    seaFreight: "Seefracht",
    
    // Buttons
    compareNow: "Jetzt vergleichen",
    submitRequest: "Jetzt buchen",
    processing: "...",
    understood: "Verstanden",
    
    // Messages
    comingSoon: "Bald verfügbar!",
    comingSoonMessage: "Diese Funktion wird in Kürze zur Verfügung stehen. Wir arbeiten daran, Ihnen den besten Service zu bieten. Vielen Dank für Ihre Geduld!",
    pleaseEnterAddresses: "Bitte geben Sie Abhol- und Lieferadressen ein",
    pleaseSelectCustomerType: "Bitte wählen Sie Ihren Kundentyp aus",
    pleaseSelectShippingMethod: "Bitte wählen Sie eine Versandart aus",
    errorOccurred: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    searching: "Suche...",
    nationalOnlySwiss: "Für nationale Sendungen müssen beide Orte in der Schweiz sein",
    internationalNeedsAbroad: "Für internationale Sendungen muss mindestens ein Ort außerhalb der Schweiz sein",
    // Aria labels
    clear: "Löschen",
  },
  en: {
    // Labels
    pickup: "Pickup",
    delivery: "Delivery",
    youAre: "You are",
    shippingMethod: "Shipping Method",
    
    // Placeholders
    enterCityOrZip: "Enter place or ZIP code",
    
    national: "National Shipping",
    international: "International Shipping",

    // Options
    selection: "Select",
    company: "Business",
    private: "Private",
    landFreight: "Land Freight",
    airFreight: "Air Freight",
    seaFreight: "Sea Freight",
    
    // Buttons
    compareNow: "Compare Now",
    submitRequest: "Submit Request",
    processing: "Processing...",
    understood: "Got it",
    
    // Messages
    comingSoon: "Coming Soon!",
    comingSoonMessage: "This feature will be available soon. We are working to provide you with the best service. Thank you for your patience!",
    pleaseEnterAddresses: "Please enter pickup and delivery addresses",
    pleaseSelectCustomerType: "Please select your customer type",
    pleaseSelectShippingMethod: "Please select a shipping method",
    errorOccurred: "An error occurred. Please try again later.",
    searching: "Searching...",
    nationalOnlySwiss: "For national shipments, both locations must be in Switzerland",
    internationalNeedsAbroad: "For international shipments, at least one location must be outside Switzerland",
    
    // Aria labels
    clear: "Clear",
  },
  fr: {
    // Labels
    pickup: "Enlèvement",
    delivery: "Livraison",
    youAre: "Vous êtes",
    shippingMethod: "Mode d'expédition",
    
    // Placeholders
    enterCityOrZip: "Entrer lieu ou code postal",
    
    // Tabs
    national: "Expédition nationale",
    international: "Expédition internationale",

    // Options
    selection: "Sélectionner",
    company: "Entreprise",
    private: "Privé",
    landFreight: "Transport terrestre",
    airFreight: "Transport aérien",
    seaFreight: "Transport maritime",
    
    // Buttons
    compareNow: "Comparer maintenant",
    submitRequest: "Soumettre la demande",
    processing: "Traitement...",
    understood: "Compris",
    
    // Messages
    comingSoon: "Bientôt disponible!",
    comingSoonMessage: "Cette fonctionnalité sera bientôt disponible. Nous travaillons pour vous offrir le meilleur service. Merci de votre patience!",
    pleaseEnterAddresses: "Veuillez entrer les adresses d'enlèvement et de livraison",
    pleaseSelectCustomerType: "Veuillez sélectionner votre type de client",
    pleaseSelectShippingMethod: "Veuillez sélectionner un mode d'expédition",
    errorOccurred: "Une erreur s'est produite. Veuillez réessayer plus tard.",
    searching: "Recherche...",
    nationalOnlySwiss: "Pour les envois nationaux, les deux lieux doivent être en Suisse",
    internationalNeedsAbroad: "Pour les envois internationaux, au moins un lieu doit être hors de Suisse",
    
    // Aria labels
    clear: "Effacer",
  },
  it: {
    // Labels
    pickup: "Ritiro",
    delivery: "Consegna",
    youAre: "Tu sei",
    shippingMethod: "Metodo di spedizione",
    
    // Placeholders
    enterCityOrZip: "Inserisci luogo o CAP",
    
    // Tabs
    national: "Spedizione nazionale",
    international: "Spedizione internazionale",

    // Options
    selection: "Seleziona",
    company: "Azienda",
    private: "Privato",
    landFreight: "Trasporto terrestre",
    airFreight: "Trasporto aereo",
    seaFreight: "Trasporto marittimo",
    
    // Buttons
    compareNow: "Confronta ora",
    submitRequest: "Invia richiesta",
    processing: "Elaborazione...",
    understood: "Capito",
    
    // Messages
    comingSoon: "Prossimamente!",
    comingSoonMessage: "Questa funzione sarà disponibile a breve. Stiamo lavorando per offrirti il miglior servizio. Grazie per la pazienza!",
    pleaseEnterAddresses: "Inserisci gli indirizzi di ritiro e consegna",
    pleaseSelectCustomerType: "Seleziona il tipo di cliente",
    pleaseSelectShippingMethod: "Seleziona un metodo di spedizione",
    errorOccurred: "Si è verificato un errore. Riprova più tardi.",
    searching: "Ricerca...",
    nationalOnlySwiss: "Per le spedizioni nazionali, entrambi i luoghi devono essere in Svizzera",
    internationalNeedsAbroad: "Per le spedizioni internazionali, almeno un luogo deve essere fuori dalla Svizzera",
    
    // Aria labels
    clear: "Cancella",
  }
};

// Helper hook to get translations
export const useTranslations = (language?: 'de' | 'en' | 'fr' | 'it'): Translations => {
  // If language is explicitly provided, use it
  if (language) {
    return translations[language];
  }
  
  // Otherwise, check if we're in an iframe and if parent URL contains talatruck.webflow.io
  const isEnglish = (() => {
    try {
      // Check if we're in an iframe
      if (window.self !== window.top && window.parent) {
        // Try to access parent URL (this might be blocked by same-origin policy)
        try {
          const parentUrl = window.parent.location.href;
          return parentUrl.includes('talatruck.webflow.io');
        } catch (e) {
          // If we can't access parent URL due to CORS, check document referrer
          return document.referrer.includes('talatruck.webflow.io');
        }
      }
      // Also check current window URL as fallback
      return window.location.href.includes('talatruck.webflow.io');
    } catch (e) {
      return false;
    }
  })();
  
  return isEnglish ? translations.en : translations.de;
};